import { COLOR } from '@cosuno/cosuno-ui';
import { Dialog } from '@cosuno/modal-frontend';
import Color from 'color';
import styled from 'styled-components';

export const Content = styled(Dialog.Content)`
  position: relative;
`;

export const TextContent = styled.div`
  width: 400px;
`;

export const Description = styled(Dialog.Paragraph)`
  color: ${COLOR.textPrimary};
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 30px;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  color: ${COLOR.textSecondary};
`;

export const IconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Color(COLOR.highlightNeon).alpha(0.05).toString()};
  border-radius: 50%;
  padding: 10px;
`;

export const Illustration = styled.img`
  position: absolute;
  left: 370px;
  top: 50px;
  height: 350px;
`;
